import { setEditPersonalInfoModal } from '../../../../../store/workspace/slice';
import { UserAttributes } from '../../../../../store/workspace/types';
import { EditIcon } from '../../../../../assets/icons/common';
import { useDispatch } from '../../../../../store/store';
import styles from './style.module.scss';

interface Props {
    salary: string | undefined;
    data: UserAttributes | null;
    visaStatus: string | undefined;
};

export default function PersonalInformation(props: Props) {
    const dispatch = useDispatch();
    const { data, salary, visaStatus } = props;

    return (
        <div className={styles.wrapper}>
            <div className={styles.content}>
                <div className={styles.content_headbar}>
                    <span className={styles.content_headbar_title}>Personal information</span>
                    <div className={styles.content_headbar_actions}>
                        <EditIcon onClick={() => dispatch(setEditPersonalInfoModal(true))} />
                    </div>
                </div>
                <div className={styles.content_main}>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Full name</span>
                        <span className={styles.content_main_row_val}>{data?.given_name} {data?.family_name}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Phone number</span>
                        <span className={styles.content_main_row_val}>{data?.phone_number}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Preferred name</span>
                        <span className={styles.content_main_row_val}>{data?.['custom:preferredName'] || '----'}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Email</span>
                        <span className={styles.content_main_row_val}>{data?.email}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>DOB</span>
                        <span className={styles.content_main_row_val}>{data?.birthdate}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>City</span>
                        <span className={styles.content_main_row_val}>{data?.['custom:city'] || '----'}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Country</span>
                        <span className={styles.content_main_row_val}>{data?.['custom:country'] || '----'}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Address</span>
                        <span className={styles.content_main_row_val}>{data?.address}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Zip code</span>
                        <span className={styles.content_main_row_val}>{data?.['custom:zipCode'] || '----'}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>State</span>
                        <span className={styles.content_main_row_val}>{data?.['custom:state'] || '----'}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>LinkdIn link</span>
                        <span className={styles.content_main_row_val}>{data?.['custom:linkedinLink'] || '----'}</span>
                    </div>
                </div>
            </div>
            <div className={styles.content}>
                <div className={styles.content_headbar}>
                    <span className={styles.content_headbar_title}>Salary & visa</span>
                    <div className={styles.content_headbar_actions}>

                    </div>
                </div>
                <div className={styles.content_main}>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Salary expectation</span>
                        <span className={styles.content_main_row_val}>{salary ? `${salary}$` : '----'}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>e.g. H-1B visa status requirement</span>
                        <span className={styles.content_main_row_val}>{visaStatus}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}
